import { Routes } from '@angular/router';

import { ROUTE_NAMES } from '@constants';
import { i18nResolver, userBeanResolver } from 'src/app/core/resolvers';

export const sharedWithMeRoutes: Routes = [
  {
    path: 'shared-with-me',
    title: 'WEB_SHARED_WITH_ME',
    resolve: {
      agorai18n: i18nResolver,
      userBean: userBeanResolver,
    },
    loadComponent: () =>
      import('./pages/shared-with-me.component').then(
        (m) => m.SharedWithMeComponent
      ),
    data: { navigationRoute: ROUTE_NAMES.ROOMS },
  },
];
